import { Avatar, Box, Button, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { API_BASE, authFetch } from "../../Utils/apiClient";

const Profile = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [adminData, setAdminData] = useState({});
  const [userDetails, setUserDetails] = useState({
    Name: "",
    "Email Address": "",
    ProfileImage: "",
  });
  useEffect(() => {
    const getAdminData = async () => {
      const adminId = localStorage.getItem("adminId");
      if (!adminId) return;
      try {
        const res = await authFetch(`/admin/getAdminById/${adminId}`);
        const data = await res.json();
        if (data?.id) {
          setAdminData(data);
          setUserDetails({
            Name: data.name,
            "Email Address": data.email,
            ProfileImage: data.image,
          });
        }
      } catch (err) {
        console.error(err);
      }
    };
    getAdminData();
  }, []);

  return (
    <Box m="20px">
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom="20px">
        <Header title="My Profile" subtitle="" />
        <Box>
          <Link to={"changepassword"} style={{ marginRight: "10px" }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#6870fa",
                color: "white",
                fontSize: "16px",
                "&:hover": {
                  backgroundColor: "#3e4396",
                },
              }}>
              Change Password
            </Button>
          </Link>
          <Link to={"editprofile"}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#6870fa",
                color: "white",
                fontSize: "16px",
                "&:hover": {
                  backgroundColor: "#3e4396",
                },
              }}>
              Edit Profile
            </Button>
          </Link>
        </Box>
      </Box>
      <Box display="flex" alignItems="center">
        <Avatar
          alt="User Avatar"
          src={userDetails.ProfileImage} // Use fetched profile picture
          sx={{ width: 200, height: 200, marginRight: "20px" }}
        />

        <Box>
          <Typography variant="h3" gutterBottom>
            {userDetails.Name} {/* Display fetched name */}
          </Typography>
          <Typography variant="h4" gutterBottom>
            {userDetails["Email Address"]} {/* Display fetched email */}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Profile;
